import styled from "styled-components";

import { LoginWaitingForBroker } from "@/assets/images";
import { breakpoints } from "@/styles/breakpoints";

export const WaitingForBrokerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(90vh - 142px);
`;

export const WaitingForBrokerImage = styled(LoginWaitingForBroker)`
    margin-bottom: 50px;
    @media ${breakpoints.sm} {
        width: 260px;
        margin-bottom: 40px;
    }
    @media ${breakpoints.xs} {
        width: 10rem;
        height: 8rem;
        margin-bottom: 40px;
    }
`;

export const WaitingForBrokerTitle = styled.div`
    font-size: var(--size-24);
    font-style: normal;
    font-weight: bold;
    line-height: 31px;
    color: var(--color-primary);
    text-align: center;
    @media ${breakpoints.sm} {
        font-size: var(--size-18);
    }
    @media ${breakpoints.xs} {
        font-size: var(--size-18);
    }
`;

export const WaitingForBrokerMessage = styled.p`
    width: 30%;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: var(--color-grey-800);
    text-align: center;
    @media ${breakpoints.sm} {
        width: 50%;
        font-size: var(--size-14);
    }
    @media ${breakpoints.xs} {
        width: 100%;
        font-size: var(--size-14);
    }
`;
